import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { EFormPaymentTestPMToken, EFormPaymentTestKonbiniNumber } from './form-test-buttons.enum';
import { IFormCustomerInfoData } from '../form-customer-info/form-customer-info.interfaces';
import { IFormPaymentData } from '../form-payment/form-payment.interfaces';
import { EFormPaymentType } from '../form-payment/form-payment.enums';
import { IFormDataShippingAddress } from 'src/app/pages/order/interfaces';

@Component({
  selector: 'app-form-test-buttons',
  templateUrl: './form-test-buttons.component.html',
  styleUrls: ['./form-test-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTestButtonsComponent {
  @Output() stepChange = new EventEmitter<1 | 2 | 3>();

  @Output() customerInfoChange = new EventEmitter<Partial<IFormCustomerInfoData>>();

  @Output() shippingAddressChange = new EventEmitter<Partial<IFormDataShippingAddress>>();

  @Output() paymentDataChange = new EventEmitter<Partial<IFormPaymentData>>();

  public readonly EFormPaymentTestPMToken = EFormPaymentTestPMToken;

  public readonly EFormPaymentTestKonbiniNumber = EFormPaymentTestKonbiniNumber;

  constructor() { }

  /**
   * filling the customer info form group with test data
   */
  public fillCustomerInfo(): void {
    this.customerInfoChange.emit({
      lastName: 'えぉおかが',
      firstName: 'きぎくぐけ',
      postalCodeFirst: '123',
      postalCodeSecond: '4567',
      addressFirst: '0',
      addressSecond: 'えぉおかが',
      addressThird: 'きぎくぐけ',
      phoneFirst: '123',
      phoneSecond: '4567',
      phoneThird: '8901',
      email: 'test@mail.com',
      email2: 'test@mail.com',
      emailReceive: true,
    });
  }

  // /**
  //  * filling the shipping address form group with test data
  //  */
  public fillShippingAddress(): void {
    this.shippingAddressChange.emit({
      lastName: 'きぎくぐけ',
      firstName: 'えぉおかが',
      postalCodeFirst: '890',
      postalCodeSecond: '1234',
      addressFirst: '1',
      addressSecond: 'きぎくぐけ',
      addressThird: 'えぉおかが',
      phoneFirst: '234',
      phoneSecond: '5678',
      phoneThird: '9012',
    });
  }

  /**
   * fill the payment form group with test data
   */
  public fillPaymentCard(
    pmToken: EFormPaymentTestPMToken,
  ): void {
    this.paymentDataChange.emit({
      type: EFormPaymentType.card,
      card: null,
      name: 'えぉおかが',
      pmToken,
      terms: true,
    });
  }

  public fillPaymentKonbini(
    phone: EFormPaymentTestKonbiniNumber,
  ): void {
    this.paymentDataChange.emit({
      type: EFormPaymentType.konbini,
      terms: true,
    });

    this.customerInfoChange.emit({
      phoneFirst: phone.substring(0, 3),
      phoneSecond: phone.substring(3, 7),
      phoneThird: phone.substring(7, 11),
    });
  }
}
